import { CLessonInCourse, LESSONS_TYPES, Course } from '@yandex-int/k-common/typings';
import { useAppContext } from 'platform-components/common';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useMount } from 'react-use';

import * as teamActions from 'common.components/classes/actions';
import * as teamSelectors from 'common.components/classes/selectors';
import { iClass } from 'common.components/typings';
import { actions as coursesActions } from 'store/courses/actions';

import { specCourseActions } from '../spec-course.store/actions';

import { SpecCourseLessonsPageContainer } from './lessons-page.container';

const TYPES_TO_LOAD = [LESSONS_TYPES.ASSIGNED, LESSONS_TYPES.FINISHED];

export const SpecCourseLessonsPageSSRContainer = () => {
    const dispatch = useDispatch();

    const { courseId, classId: clId } = useParams<{ courseId: string; classId: string }>();
    const { initialRender, data } = useAppContext();
    const classId = Number(clId);
    const specCourseId = Number(courseId);

    const shouldLoadTeamData = useSelector((store) => teamSelectors.getShouldLoadTeamData(store, { classId }));

    const clessonsData = data.getLessons as { clessons: Array<CLessonInCourse> };
    const courses = data.getCourses as Array<Course>;
    const team = data.getClasses as iClass;

    useMount(function setLessons() {
        if (initialRender) {
            if (courses) {
                dispatch(coursesActions.getCoursesByTeamSuccess({ teamId: classId, courses }));
                loadLessons();
            }
            if (team) {
                dispatch(teamActions.getClassSuccess(classId, team));
            } else {
                loadTeamData();
            }
        }
    });

    const loadLessons = () => {
        const types = initialRender // на SSR грузятся активные уроки
            ? TYPES_TO_LOAD
            : [LESSONS_TYPES.ACTIVE, ...TYPES_TO_LOAD];

        dispatch(specCourseActions.setLessons({ clessons: clessonsData?.clessons }));
        dispatch(
            specCourseActions.getLessons({
                courseId: specCourseId,
                types,
                prevClessons: clessonsData?.clessons,
            })
        );
    };

    const loadTeamData = () => {
        if (shouldLoadTeamData) {
            dispatch(teamActions.getTeam(classId));
        }
    };

    return <SpecCourseLessonsPageContainer />;
};
